import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ContentOuterWrap = ({ children, ...props }) => {
  return (
    <div className={styles.wrapper} {...props}>
      {children}
    </div>
  );
};

ContentOuterWrap.propTypes = {
  children: PropTypes.node,
};

export default ContentOuterWrap;
